export default {
  name: 'school-safety',
  path: '/school-safety',
  meta: {
    title: '安全中心'
  },
  redirect: '/school-safety/attendance',
  children: [
    // 考勤
    {
      name: 'safety-attendance',
      path: 'attendance',
      meta: {
        title: '考勤管理'
      },
      redirect: '/school-safety/attendance/check-new',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance'),
      children: [
        {
          name: 'attendance-check-new',
          path: 'check-new',
          fullPath: '/school-safety/attendance/check-new',
          meta: {
            title: '考勤管理(新版)'
          },
          redirect: '/school-safety/attendance/check-new/detail',
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-new'),
          children: [
            {
              name: 'check-new-detail',
              path: 'detail',
              fullPath: '/school-safety/attendance/check-new/detail',
              meta: {
                // title: '考勤明细(新版)'
              },
              component: () =>
                import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-new/detail')
            },
            {
              name: 'check-new-rule',
              path: 'rule',
              fullPath: '/school-safety/attendance/check-new/rule',
              meta: {
                // title: '考勤管理(新版)'
              },
              component: () =>
                import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-new/rule')
            }
          ]
        },
        {
          name: 'attendance-check-former',
          path: 'check-former',
          fullPath: '/school-safety/attendance/check-former',
          meta: {
            title: '考勤管理(旧版)'
          },
          redirect: '/school-safety/attendance/check-former/detail',
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-former'),
          children: [
            {
              name: 'check-former-detail',
              path: 'detail',
              fullPath: '/school-safety/attendance/check-former/detail',
              meta: {
                // title: '考勤明细(旧版)'
              },
              component: () =>
                import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-former/detail')
            },
            {
              name: 'check-former-rule',
              path: 'rule',
              fullPath: '/school-safety/attendance/check-former/rule',
              meta: {
                // title: '考勤管理(旧版)'
              },
              component: () =>
                import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-former/rule')
            }
          ]
        },
        {
          name: 'attendance-check-rerun',
          path: 'check-rerun',
          fullPath: '/school-safety/attendance/check-rerun',
          meta: {
            // title: '考勤明细重算'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-rerun')
        },
        {
          name: 'attendance-summary',
          path: 'summary',
          fullPath: '/school-safety/attendance/summary',
          meta: {
            // title: '考勤汇总'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/summary')
        },
        {
          name: 'attendance-attendance-rate',
          path: 'attendance-rate',
          fullPath: '/school-safety/attendance/attendance-rate',
          meta: {
            // title: '考勤率'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/attendance-rate')
        },
        {
          name: 'attendance-swipe-record',
          path: 'swipe-record',
          fullPath: '/school-safety/attendance/swipe-record',
          meta: {
            // title: '刷卡记录'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/swipe-record')
        },
        {
          name: 'attendance-access-control-rules',
          path: 'access-control-rules',
          fullPath: '/school-safety/attendance/access-control-rules',
          meta: {
            // title: '门禁规则'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/access-control-rules')
        },
        {
          name: 'attendance-check-label',
          path: 'check-label',
          fullPath: '/school-safety/attendance/check-label',
          meta: {
            // title: '考勤标签管理'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/check-label')
        },
        {
          name: 'attendance-carousel',
          path: 'carousel',
          fullPath: '/school-safety/attendance/carousel',
          meta: {
            // title: '大屏轮播管理'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/attendance/carousel')
        },
        {
          name: 'sign-in-qrcode',
          path: '/school-safety/attendance/sign-in-qrcode',
          meta: {
            title: '签到二维码'
          },
          component: () =>
            import(/* webpackChunkName: "recipes-management" */ '@/views/school-safety/attendance/sign-in-qrcode')
        }
      ]
    },
    // 黑名单
    // 直播
    {
      name: 'safety-living',
      path: 'living',
      meta: {
        title: '学校视频直播管理',
        icon: 'icon-home'
      },
      redirect: '/school-safety/living/account-management',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living'),
      children: [
        {
          name: 'living-account-management',
          path: 'account-management',
          fullPath: '/school-safety/living/account-management',
          meta: {
            // title: '账户管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/account-management')
        },
        {
          name: 'living-financial-detail',
          path: 'financial-detail',
          fullPath: '/school-safety/living/financial-detail',
          meta: {
            // title: '财务明细',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/financial-detail')
        },
        {
          name: 'living-service-management',
          path: 'service-management',
          fullPath: '/school-safety/living/service-management',
          meta: {
            // title: '服务管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/service-management')
        },
        {
          name: 'living-camera-management',
          path: 'camera-management',
          fullPath: '/school-safety/living/camera-management',
          meta: {
            // title: '摄像头管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/camera-management')
        },
        {
          name: 'living-order-export',
          path: 'order-export',
          fullPath: '/school-safety/living/order-export',
          meta: {
            title: '交易订单导出',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/order-export')
        },
        {
          name: 'living-equipment-manage',
          path: 'equipment-manage',
          fullPath: '/school-safety/living/equipment-manage',
          meta: {
            title: '设备状态日志',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/living/equipment-manage')
        }
      ]
    },
    // 校车
    {
      name: 'safety-bus',
      path: 'bus',
      meta: {
        title: '校车管理',
        icon: 'icon-home'
      },
      redirect: '/school-safety/bus/bus-management',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/bus'),
      children: [
        {
          name: 'bus-bus-management',
          path: 'bus-management',
          fullPath: '/school-safety/bus/bus-management',
          meta: {
            // title: '校车管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/bus/bus-management')
        },
        {
          name: 'bus-operation-time',
          path: 'operation-time',
          fullPath: '/school-safety/bus/operation-time',
          meta: {
            // title: '校车运作时间管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/bus/operation-time')
        },
        {
          name: 'bus-record',
          path: 'record',
          fullPath: '/school-safety/bus/record',
          meta: {
            // title: '校车记录',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/bus/record')
        }
      ]
    },
    // 人脸
    {
      name: 'safety-face',
      path: 'face',
      meta: {
        title: '人脸识别功能管理',
        icon: 'icon-home'
      },
      redirect: '/school-safety/face/service-management',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face'),
      children: [
        {
          name: 'face-service-management',
          path: 'service-management',
          fullPath: '/school-safety/face/service-management',
          meta: {
            // title: '服务管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/service-management')
        },
        {
          name: 'service-management-new',
          path: 'service-management-new',
          fullPath: '/school-safety/face/service-management-new',
          meta: {
            title: '服务管理(新版)',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/service-management-new')
        },
        {
          name: 'discern-log',
          path: 'discern-log',
          fullPath: '/school-safety/face/discern-log',
          meta: {
            title: '识别记录',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/discern-log')
        },
        {
          name: 'face-face-recognition-record',
          path: 'face-recognition-record',
          fullPath: '/school-safety/face/face-recognition-record',
          meta: {
            // title: '考勤识别记录',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/face-recognition-record')
        },
        {
          name: 'face-face-manage',
          path: 'face-manage',
          fullPath: '/school-safety/face/face-manage',
          meta: {
            // title: '人脸库管理',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/face-manage')
        },
        {
          name: 'face-push-astrict',
          path: 'push-astrict',
          fullPath: '/school-safety/face/push-astrict',
          meta: {
            // title: '推送限制',
            icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/push-astrict')
        },
        {
          name: 'batch-face-entry',
          path: 'batch-face-entry',
          fullPath: '/school-safety/face/batch-face-entry',
          meta: {
            title: '批量录入人脸'
            // icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/batch-face-entry')
        },
        {
          name: 'historical-details',
          path: 'historical-details',
          fullPath: '/school-safety/face/batch-face-entry/historical-details',
          meta: {
            title: '批量录入详情'
            // icon: 'icon-home'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/face/batch-face-entry/historical-details')
        }
      ]
    },
    // 白名单后台
    {
      name: 'safety-epidemic-prevention',
      path: '/school-safety/epidemic-prevention',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/epidemic-prevention')
    },
    // 在线巡检
    {
      name: 'safety-online-patrol',
      path: 'online-patrol',
      meta: {
        title: '在线巡检',
        icon: 'icon-home'
      },
      redirect: '/school-safety/online-patrol/video-grouping',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/online-patrol'),
      children: [
        {
          name: 'online-patrol-video-grouping',
          path: '/video-grouping',
          meta: {
            title: '视频分组'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/online-patrol/video-grouping')
        },
        {
          name: 'online-patrol-view-online',
          path: '/view-online',
          // meta: {
          // 	title: '在线巡检'
          // },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/online-patrol/view-online')
        }
      ]
    },
    // 防欺凌-弘卫士
    {
      name: 'anti-bullying',
      path: 'anti-bullying',
      meta: {
        title: '防欺凌-弘卫士',
        icon: 'icon-home'
      },
      redirect: '/school-safety/anti-bullying/device-manager',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying'),
      children: [
        {
          name: 'anti-bullying-device-manager',
          path: 'device-manager',
          fullPath: '/school-safety/anti-bullying/device-manager',
          meta: {
            title: '设备管理员-弘卫士'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying/device-manager')
        },
        {
          name: 'anti-bullying-manager-list',
          path: 'device-manager-list',
          fullPath: '/school-safety/anti-bullying/device-manager-list',
          meta: {
            title: '设备管理员列表-弘卫士'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying/device-manager-list')
        },
        {
          name: 'anti-bullying-device-log',
          path: 'device-log',
          fullPath: '/school-safety/anti-bullying/device-log',
          meta: {
            title: '设备报警信息-弘卫士'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying/device-log')
        }
      ]
    },
    // 防欺凌-笛虎
    {
      name: 'anti-bullying-DH',
      path: 'anti-bullying-DH',
      meta: {
        title: '防欺凌-笛虎',
        icon: 'icon-home'
      },
      redirect: '/school-safety/anti-bullying-DH/device-manager',
      component: () =>
        import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying-DH'),
      children: [
        {
          name: 'anti-bullying-device-manager-dh',
          path: 'device-manager',
          fullPath: '/school-safety/anti-bullying-DH/device-manager',
          meta: {
            title: '设备管理员-笛虎'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying-DH/device-manager')
        },
        {
          name: 'anti-bullying-manager-list-dh',
          path: 'device-manager-list',
          fullPath: '/school-safety/anti-bullying-DH/device-manager-list',
          meta: {
            title: '设备管理员列表-笛虎'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying-DH/device-manager-list')
        },
        {
          name: 'anti-bullying-device-log-dh',
          path: 'device-log',
          fullPath: '/school-safety/anti-bullying-DH/device-log',
          meta: {
            title: '设备报警信息-笛虎'
          },
          component: () =>
            import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/anti-bullying-DH/device-log')
        }
      ]
    },
    // 可视化放学管理
    {
      name: 'school-dismissal',
      path: 'school-dismissal',
      meta: {
        title: '可视化放学管理'
      },
      redirect: '/school-safety/school-dismissal/school',
      component: () =>
          import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/school-dismissal'),
      children: [
        {
          name: 'school-dismissal-school',
          path: 'school',
          fullPath: '/school-safety/school-dismissal/school',
          meta: {
            title: '放学管理'
          },
          component: () =>
              import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/school-dismissal/school')
        },
        {
          name: 'school-dismissal-setting',
          path: 'setting',
          fullPath: '/school-safety/school-dismissal/setting',
          meta: {
            title: '设置'
          },
          component: () =>
              import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/school-dismissal/setting')
        },
        {
          name: 'school-dismissal-click-dismissal',
          path: 'click-dismissal',
          fullPath: '/school-safety/school-dismissal/click-dismissal',
          meta: {
            title: '一键放学'
          },
          component: () =>
              import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/school-dismissal/click-dismissal')
        },
        {
          name: 'school-dismissal-status-history',
          path: 'status-history',
          fullPath: '/school-safety/school-dismissal/status-history',
          meta: {
            title: '放学状态记录'
          },
          component: () =>
              import(/* webpackChunkName: "school-safety" */ '@/views/school-safety/school-dismissal/status-history')
        }
      ]
    }
  ]
};
